export default "__VITE_ASSET__DuQX5xMC__"